import { SocialLogin } from "@capgo/capacitor-social-login";
import { isNativeApp } from "@/lib/runtime";

let initializationPromise;

function getWebClientId() {
  return process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim() || "";
}

export function canUseNativeGoogleAuth() {
  return isNativeApp() && Boolean(getWebClientId());
}

export function initializeNativeGoogleAuth() {
  if (!canUseNativeGoogleAuth()) {
    return Promise.reject(new Error("Native Google-inloggning saknar konfiguration."));
  }

  if (!initializationPromise) {
    initializationPromise = SocialLogin.initialize({
      google: {
        webClientId: getWebClientId(),
        mode: "online",
      },
    }).catch((error) => {
      initializationPromise = undefined;
      throw error;
    });
  }

  return initializationPromise;
}

export async function signInWithNativeGoogle() {
  await initializeNativeGoogleAuth();

  const response = await SocialLogin.login({
    provider: "google",
    options: {
      style: "bottom",
      filterByAuthorizedAccounts: false,
      autoSelectEnabled: false,
    },
  });

  const idToken = response?.result?.idToken;
  if (!idToken) {
    throw new Error("Google returnerade inget ID-token.");
  }

  return idToken;
}

export async function signOutNativeGoogle() {
  if (!canUseNativeGoogleAuth()) return;

  await initializeNativeGoogleAuth();
  await SocialLogin.logout({ provider: "google" });
}
